import Swiper from 'swiper/bundle';

function initSliders() {
	var gallerySlider = $('.gallery-slider');
	if (gallerySlider.length) {
		gallerySlider.each(function() {
			window.slider = new Swiper($(this)[0], {
				slidesPerView: 1,
				spaceBetween: 32,
				autoHeight: true,
				speed: 600,
				autoplay: false,
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				freeMode: false,
				loop: false,
				touchEventsTarget: 'wrapper',
				on: {
					init: function () {
						// console.log('swiper initialized');

					},
					resize: function () {

					},
				},
			});
		});
	}

	var lessonSlider = $('.slider-thumbnail');
	if (lessonSlider.length) {
		// Initialize multiple sliders and thumbnails
		$('.slider-thumbnail').each(function() {
			var sliderId = $(this).data('slider');
			var sliderClass = '.slider[data-slider="' + sliderId + '"]';

			var sliderThumbnail = new Swiper($(this)[0], {
				slidesPerView: 'auto',
				spaceBetween: 11,
				autoHeight: true,
				freeMode: true,
				watchSlidesVisibility: true,
				watchSlidesProgress: true,
				mousewheel: {
					releaseOnEdges: true,
					forceToAxis: true,
				},
			});

			var slider = new Swiper('.slider[data-slider="' + sliderId + '"]', {
				navigation: false,
				autoHeight: true,
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				thumbs: {
					swiper: sliderThumbnail
				}
			});
		});
	}
}

initSliders();

document.addEventListener('afterBlitzInject', function (event) { 
	console.log('sliders.js afterBlitzInject')
	initSliders();
});

window.initFavouriteSlider = function initFavouriteSlider() {
	var favouriteSlider = $('.favourite-slider');
	var favouriteSliderSection = $('.favourite-lessons-section');
	if (favouriteSlider.length) {
		window.slider = new Swiper('.favourite-slider', {
			slidesPerView: 1,
			spaceBetween: 16,
			autoHeight: false,
			speed: 600,
			autoplay: false,
			navigation: {
				nextEl: favouriteSliderSection.find('.swiper-button-next')[0],
				prevEl: favouriteSliderSection.find('.swiper-button-prev')[0],
			},
			scrollbar: false,
			pagination: {
				el: '.favourite-slider-pagination',
				type: 'bullets',
				clickable: true,
			},
			freeMode: false,
			loop: false,
			touchEventsTarget: 'wrapper',
			breakpoints: {
				640: {
					slidesPerView: 1.8,
				},
				768: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 2.5,
				},
				1280: {
					slidesPerView: 4,
					freeMode: {
						enabled: true,
						sticky: false,
					},
				},
			},
			on: {
				init: function () {
					// console.log('swiper initialized');

					favouriteSlider.on('mousemove', function(event) {
						var distanceToRightEdge = favouriteSlider.width() - (event.pageX - favouriteSlider.offset().left);
						if (distanceToRightEdge <= 200) {
							favouriteSliderSection.find('.swiper-button-next').addClass('shown');
						} else {
							favouriteSliderSection.find('.swiper-button-next').removeClass('shown');
						}
						var distanceToLeftEdge = event.pageX - favouriteSlider.offset().left;
						if (distanceToLeftEdge <= 200) {
							favouriteSliderSection.find('.swiper-button-prev').addClass('shown');
						} else {
							favouriteSliderSection.find('.swiper-button-prev').removeClass('shown');
						}
					});
				},
				resize: function () {
					var marginTop = 20 + favouriteSlider.find('.image-container').first().height() / 2 - favouriteSliderSection.find('.swiper-button').first().height() / 2;
					if (marginTop > 20) {
						favouriteSliderSection.find('.swiper-button').css('margin-top', marginTop + 'px');
					}
				},
			},
		});
	}
}


initFavouriteSlider();






var featuredSliderSection = $('.featured-slider-section');
var featuredSlider = $('.featured-slider');
if (featuredSlider.length) {
	window.slider = new Swiper('.featured-slider', {
		slidesPerView: 1,
		spaceBetween: 16,
		autoHeight: false,
		speed: 600,
		autoplay: false,
		navigation: {
			nextEl: featuredSliderSection.find('.swiper-button-next')[0],
			prevEl: featuredSliderSection.find('.swiper-button-prev')[0],
		},
		scrollbar: false,
		pagination: {
			el: '.featured-slider-pagination',
			type: 'bullets',
			clickable: true,
		},
		freeMode: false,
		loop: false,
		touchEventsTarget: 'wrapper',
        breakpoints: {
            640: {
				slidesPerView: 1.8,
            },
            768: {
				slidesPerView: 2,
            },
            1024: {
				slidesPerView: 2.5,
            },
            1280: {
				slidesPerView: 4,
				freeMode: {
					enabled: true,
					sticky: false,
				},
            },
        },
        on: {
            init: function () {
                // console.log('swiper initialized');

				featuredSlider.on('mousemove', function(event) {
					var distanceToRightEdge = featuredSlider.width() - (event.pageX - featuredSlider.offset().left);
					if (distanceToRightEdge <= 200) {
						featuredSliderSection.find('.swiper-button-next').addClass('shown');
					} else {
						featuredSliderSection.find('.swiper-button-next').removeClass('shown');
					}
					var distanceToLeftEdge = event.pageX - featuredSlider.offset().left;
					if (distanceToLeftEdge <= 200) {
						featuredSliderSection.find('.swiper-button-prev').addClass('shown');
					} else {
						featuredSliderSection.find('.swiper-button-prev').removeClass('shown');
					}
				});
            },
            resize: function () {
				var marginTop = 20 + featuredSlider.find('.image-container').first().height() / 2 - featuredSliderSection.find('.swiper-button').first().height() / 2;
				if (marginTop > 20) {
					featuredSliderSection.find('.swiper-button').css('margin-top', marginTop + 'px');
				}
            },
        },
	});
}